import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useTabsClassName } from './utils';
import { TabsRoot } from './style';
import { tabsDefaultTheme } from './theme';
import { TABS_CLASS_PREFIX } from './constants';
import TabsContext from './TabsContext';
import { useTabs } from './hooks/useTabs';
export var Tabs = forwardRef(function Tabs(_ref, ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["className"]);

  var theme = useComponentTheme(TABS_CLASS_PREFIX, tabsDefaultTheme);

  var _useTabs = useTabs(restProps, ref),
      rootProps = _useTabs.rootProps,
      contextValue = _useTabs.contextValue,
      disabled = _useTabs.disabled;

  var classOverride = useTabsClassName(TABS_CLASS_PREFIX, className, disabled);
  return React.createElement(TabsContext.Provider, {
    value: contextValue
  }, React.createElement(TabsRoot, Object.assign({}, rootProps, {
    className: classOverride.Root,
    theme: theme
  })));
});
Tabs.displayName = TABS_CLASS_PREFIX;